import DesktopPricingCalculatorModal from "../modal/desktop/DesktopPricingCalculatorModal.tsx";
import MobilePricingCalculatorModal from "../modal/mobile/MobilePricingCalculatorModal.tsx";
import './Calculator.css';
import {useRef} from "react";
import useFocusTrap from "../../../../hooks/useFocusTrap.tsx";

interface Props {
    isCalculatorModalOpen: boolean,
    setIsCalculatorModalOpen: (isOpen: boolean) => void
}

const PricingCalculator = ({isCalculatorModalOpen, setIsCalculatorModalOpen}: Props) => {

    const modalRef = useRef(null);

    useFocusTrap(isCalculatorModalOpen, modalRef);

    return (
        <>
            <div className="raw-html-embed">
                <div className="opy-page-prices">
                    <div
                        ref={modalRef}
                        className={`collapse prices-example-modal ${isCalculatorModalOpen ? 'show' : ''}`}
                    >
                        <DesktopPricingCalculatorModal setIsCalculatorModalOpen={setIsCalculatorModalOpen} />
                        <MobilePricingCalculatorModal setIsCalculatorModalOpen={setIsCalculatorModalOpen} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default PricingCalculator;
